import { BalancesSummary } from './../../models/balances/index';

export abstract class BalancesMapperUtil {

    /**
     * @method getBalancesSummaryFromResponse
     * @desc returns BalancesSummary response from microservice summary response
     * @param balances
     * @return BalancesSummary
     */
    static getBalancesSummaryFromResponse(balancesSummary: any): BalancesSummary {
        // Need to know the microservice response in order to determine exact field mappings
        return {
            totalAccountWorth: balancesSummary.totalWorth,
            fundsAvailableToTrade: balancesSummary.fundsAvailableToTrade,
            fundsAvailableToWithdraw: balancesSummary.fundsAvailableToWithdraw,
            fundsDue: balancesSummary.fundsDue
        };
    }
}
